export class CalendarRevisionConflictError extends Error {
  constructor() {
    super('Calendar revision conflict');
    this.name = 'CalendarRevisionConflictError';
  }
}

export function isCalendarRevisionConflictError(
  err: unknown,
): err is CalendarRevisionConflictError {
  return err instanceof CalendarRevisionConflictError;
}
